import * as React from "react";
import { Button } from "antd";
import BaseComponent from "src/engine/ui/BaseComponent";
import UIInject, { IHandle } from "../UIInject";
import UIManifest from "src/engine/ui/UIManifest";
import IUIItem from "src/engine/interface/IUIItem";
import ButtonCheck from "src/components/Button/ButtonCheck";
import PageContext, { IPageContext } from "src/engine/pages/ui/PageContext";
import AutoContext from "src/engine/decorator/AutoContext";
import JIcon from "src/component/jj/JIcon";
import Manifest from "src/engine/Manifest";
import Electron from "src/Electorn";
import Style from "src/lib/utils/Style";

interface IAntButton {
    uiItem: IUIItem;
    icon?: string;
    onClick?: any;
    type?: string;
    stat?: { [key: string]: string };
    disable?: boolean;
    shape?: string;
    style?: any;
    className?: string;
}

interface IState {
    loading: boolean;
}

@UIManifest.declareGG(["ggValue"], "AntButton", "AntButton按钮", UIManifest.Type.AntD)
class AntButton extends BaseComponent<IAntButton, IState> {
    loading: boolean;

    state = {
        loading: false,
    };

    pageContext: IPageContext;

    unReg: any;

    componentDidMount() {
        const { command } = this.props as any;
        if (command && Electron.Instance()) {
            this.unReg = Electron.Instance().register?.(command, this.onClick);
        }
    }

    childComponentWillUnmount() {
        if (this.unReg) this.unReg();
    }

    stat() {
        const { uiItem, stat = {} } = this.props;
        const clickId = stat.clickId || uiItem.info.cname;
        if (this.pageContext && clickId) {
            this.pageContext.stat({ clickId: uiItem.info.cname, ...stat });
        }
    }

    onClick = (e?: any) => {
        if (!!this.loading) return;
        // 检查不同按钮间的重复点击
        if (!ButtonCheck.check()) return;
        //调用统计
        this.stat();
        //调用click
        const { onClick } = this.props;
        if (onClick) {
            onClick((loading: boolean) => {
                e?.stopPropagation();
                this.loading = loading;
                this.setState({ loading });
            });
        }
    };

    @AutoContext(PageContext, "pageContext")
    render() {
        const { uiItem } = this.props;
        const { wrapperCol, _updateKey, labelCol, icon, title, loadingTitle, onlyIcon, ...other } = this.props as any;
        let children: any = other.loading && loadingTitle ? loadingTitle : title || uiItem.info.cname;
        if (icon) {
            let { iconStyle } = Style.getMainStyle(["iconStyle"], this.props);
            let themeType: "white" | "dark" = "dark";
            const fontSize = other.style?.fontSize;
            if (other.type === "primary") themeType = "white"
            if (fontSize && !iconStyle.width && !iconStyle.height) iconStyle = { width: fontSize, height: fontSize, ...iconStyle };
            children = (
                <>
                    <JIcon className={onlyIcon || children === "" ? "only-icon" : ""} uiItem={Manifest.ui()} src={icon} themeType={themeType} style={iconStyle} />
                    {onlyIcon ? null : children}
                </>
            );
        }
        const handles: IHandle[] = [];
        return <UIInject ui={Button} loading={this.state.loading} children={children} {...other} onClick={this.onClick} handles={handles} />;
    }
}

export default AntButton;
